<template>
  <div class="shop-container">
    <div class="goods-list" ref="goodList" @scroll="onScrollList">
      <div class="list-box">
        <div
          class="good-item"
          v-for="(good, index) in goodsList"
          :key="index"
          @click="exchangeGift(good)"
        >
          <div class="info">
            <div class="limit user-limit" v-if="good.type == 1">
              <!-- 限兑{{ good.remain }}/{{ good.count }}次 -->
              {{ getDict(270, [good.remain, good.count]) }}
            </div>
            <div class="limit all-limit" v-if="good.type == 2">
              <!-- 剩余{{ good.count }}份 -->
              {{ getDict(271, [good.remain]) }}
            </div>
            <div
              class="gift-pic-dom"
              :style="`background-image:url(${good.icon})`"
              v-if="!!good.icon"
            />
            <!-- <img class="gift-pic" :src="good.icon" v-if="!!good.icon" /> -->
            <span class="name"
              ><autoTitle runTimeSecondLenght="5" textAlign="center">{{
                good.name
              }}</autoTitle></span
            >
          </div>

          <div class="gold">
            <i class="icon icon-gold-2" />
            <span class="red-black-text">{{ good.gold }}</span>
          </div>
        </div>
        <div
          class="good-item holder"
          v-for="index in 10"
          :key="index + 'h'"
        ></div>
      </div>
    </div>
    <gamblePopComp
      :show="!!exchangeingGift"
      boxType="title"
      :title="getDict(272) /*兑换*/"
      @close="exchangeingGift = null"
    >
      <div class="gift-pop-box" v-if="exchangeingGift">
        <div class="gift-info">
          <span class="num"
            ><i class="icon icon-gold-2" />{{ exchangeingGift.gold }}</span
          >{{ getDict(273, [exchangeingGift.name]) }}
          <!-- 兑换【{{ exchangeingGift.name }}】 -->
        </div>
        <div class="gift-open-info">
          <!-- 有机会开出道具AA、BB、CC等 -->{{
            exchangeingGift.description || ""
          }}
        </div>
        <img class="gift-icon" :src="exchangeingGift.icon" />
        <div class="button-bg done-btn" @click="exchangeDone">
          <span class="red-black-text">{{ getDict(274) /*确 定*/ }}</span>
        </div>
      </div>
    </gamblePopComp>
    <gamblePopComp
      :show="!!exchangeingGiftOk"
      boxType="title"
      :title="getDict(272) /*兑换*/"
      @close="exchangeingGiftOk = false"
    >
      <div class="gift-getted-pop-box">
        <div class="title">
          {{ getDict(276) /*兌換成功*/ }}
        </div>
        <div class="info">
          <!-- 獎勵將在24小時內發放至您的郵箱 -->{{ getDict(277) }}
        </div>
        <div class="button-bg done-btn" @click="exchangeingGiftOk = false">
          <span class="red-black-text">{{ getDict(274) /*确 定*/ }}</span>
        </div>
      </div>
    </gamblePopComp>
    <gamblePopComp
      :show="!!exchangeingGiftTime"
      boxType="title"
      :title="getDict(272) /*兑换*/"
      @close="exchangeingGiftTime = 0"
    >
      <div class="gift-getted-pop-box">
        <div class="title">
          <!-- {{ getDict(280) /*兌換失敗*/ }} -->
        </div>
        <div class="info">
          <!-- 5月1日12:00開始兌換 -->{{
            exchangeingGiftTime
              | formatDate(getDict(281, ["MM", "DD", "HH:mm"]))
          }}
        </div>
        <div class="button-bg done-btn" @click="exchangeingGiftTime = 0">
          <span class="red-black-text">{{ getDict(274) /*确 定*/ }}</span>
        </div>
      </div>
    </gamblePopComp>
    <gamblePopComp
      v-if="!!popMessage"
      :show="true"
      boxType="box"
      @close="popMessage = ''"
    >
      <div class="popMsgBox">
        <span>{{ popMessage }}</span>
      </div>
    </gamblePopComp>
  </div>
</template>

<script>
import {
  getDict,
  axios,
  getPageLevelMixin,
  webSocket,
  serverApi,
} from "../../../../common";
import store from "@/store";
import { mapState, mapGetters } from "vuex";

import gamblePopComp from "../../comps/gamble-pop-comp";
import AutoTitle from "../../../../components/autoTitle";

export default {
  name: "shopPage",
  mixins: [getPageLevelMixin],
  props: {},
  data() {
    return {
      pageLevel: 1,

      pageLimit: 30,
      devReplyTime: 0,

      goodsList: [
        // ...Array(33).fill({}).map((item,index)=>{
        //   item = {
        //     co_id:index,
        //     name:'gift' + index,
        //     icon:'https://nie.res.netease.com/r/pic/20200603/187bb5a3-5d56-4577-b2f7-552f83c10846.png',
        //     gold:index%6 * 500,
        //     type:index % 3,
        //     count:30,
        //     remain:10,
        //   }
        //   return item;
        // })
      ],
      nextCursor: 0,
      loading: false,

      popMessage: "",

      exchangeingGift: null,
      exchangeingGiftOk: false,
      exchangeingGiftTime: 0,

      listStatus: {
        height: 0,
        boxHeight: 0,
        top: 0,
      },
    };
  },
  computed: {
    ...mapState(["userData"]),
    ...mapGetters(["nowTs"]),
    goodListLength() {
      return this.goodsList.length;
    },
  },
  watch: {
    goodListLength() {
      this.$nextTick(() => {
        this.resetListStatus(true);
      });
    },
  },
  methods: {
    alertMsg(msg) {
      this.popMessage = msg;
    },
    getDict,
    exchangeGift(gift) {
      this.exchangeingGift = gift;
    },
    async exchangeDone() {
      if (!this.exchangeingGift) {
        return;
      }
      if (!this.exchangeingGift.co_id) {
        return;
      }
      if (
        this.exchangeingGift.start_ts &&
        this.exchangeingGift.start_ts * 1000 > this.nowTs
      ) {
        this.exchangeingGiftTime = this.exchangeingGift.start_ts * 1000;
        this.exchangeingGift = null;
        return;
      }
      let res = await serverApi.post("exchange", {
        co_id: this.exchangeingGift.co_id,
      });

      if (res.code == 200) {
        this.exchangeingGiftOk = true;
        store.dispatch("gambleGetUserInfo");
        if (this.exchangeingGift.type == 1) {
          this.exchangeingGift.remain--;
        } else if (this.exchangeingGift.type == 2) {
          this.exchangeingGift.count--;
        }
      } else {
        switch (res.code) {
          case 40002:
            this.alertMsg(getDict(275) /* 金币不足 */);
            return;
            break;
          case 40004: //时间不对
            this.alertMsg(getDict(278) /* 當前時間無法兌換 */);
            break;
          case 40006:
            this.alertMsg(getDict(279) /* 已兌完 */);
            break;
        }
      }
      this.exchangeingGift = null;
    },
    async getGoodsList() {
      if (this.nextCursor == -1 || this.loading) {
        return;
      }
      let pageSize = this.pageLimit;
      //调试用
      if (this.devReplyTime) {
        pageSize = Math.ceil(pageSize / this.devReplyTime);
      }
      this.loading = true;
      let res = await serverApi.get("shop", {
        cursor: this.nextCursor,
        limit: pageSize,
      });
      this.loading = false;
      if (res.code == 200) {
        if (res.data.data) {
          let addList = res.data.data;
          this.nextCursor = res.data.next_cursor;

          //调试用
          if (this.devReplyTime) {
            let list1 = [];
            for (let item of addList) {
              for (let index = 0; index < this.devReplyTime; index++) {
                list1.push({
                  ...item,
                });
              }
            }
            addList = list1;
          }
          this.goodsList = this.goodsList.concat(addList);
        }
      } else {
        this.nextCursor = -1;
      }
    },
    onScrollList() {
      this.resetListStatus();
      if (
        this.listStatus.top + 3 * this.listStatus.boxHeight >
        this.listStatus.height
      ) {
        this.getGoodsList();
      }
    },
    resetListStatus(widthChange = false) {
      if (!this.$refs.goodList) {
        return;
      }
      if (widthChange) {
        this.listStatus.boxHeight = this.$refs.goodList.clientHeight;
        this.listStatus.height = this.$refs.goodList.scrollHeight;
      }
      this.listStatus.top = this.$refs.goodList.scrollTop;
    },
  },
  components: {
    gamblePopComp,
    AutoTitle,
  },
  mounted() {
    this.$nextTick(() => {
      this.resetListStatus(true);
    });

    this.$busOn("setRemUnit", () => {
      //$busOn
      this.resetListStatus(true);
    });
  },
  created() {
    this.getGoodsList();
  },
};
</script>

<style lang="scss" scoped>
.red-black-text {
  position: relative;
  background-image: -webkit-linear-gradient(-104deg, #5c1413, #e04445);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.shop-container {
  flex: 1;
  height: 0;
  margin-top: 0.3rem;
  display: flex;
  align-items: stretch;

  // flex-direction: column;//解决部分设备商品列表超框问题
  .goods-list {
    // height: 0;//解决部分设备商品列表超框问题
    // flex:1;//解决部分设备商品列表超框问题

    // height: 100%;
    overflow-x: hidden;
    overflow-y: auto;

    .list-box {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      $good-margin: 0.1rem;
      margin: -$good-margin;

      .good-item {
        $item-height: 2.01rem;
        width: 2.11rem;
        height: $item-height;
        margin: $good-margin;
        background: url(./imgs/good-bg.png) no-repeat;
        background-size: 100% 100%;
        text-align: center;
        &.holder {
          height: 0;
          margin-top: 0;
          margin-bottom: 0;
        }

        $info-height: 0.81;
        .info {
          height: $info-height * 100%;
          position: relative;
          padding: 0.02rem;
          .limit {
            color: #fff;
            text-align: right;
            text-shadow: 0 0 0.02rem #000;
            font-size: 0.2rem;
            position: absolute;
            right: 0.02rem;
            top: 0.02rem;
            padding: 0.02rem 0.05rem;
            width: 100%;
            $linear-end: 50%;

            border: 0;
            border-bottom: 0.01rem solid;
            border-image: linear-gradient(
                to left,
                rgba(255, 255, 255, 1),
                rgba(255, 255, 255, 0) $linear-end
              )
              1 1;

            /* &.user-limit {
              background-image: linear-gradient(
                to left,
                rgba(255, 208, 92, 0.54),
                rgba(255, 208, 92, 0) $linear-end
              );
            } */
            &.user-limit {
              background-image: linear-gradient(
                to left,
                rgba(#f22e30, 0.54),
                rgba(255, 208, 92, 0) $linear-end
              );
            }
            &.all-limit {
              background-image: linear-gradient(
                to left,
                rgba(175, 115, 255, 0.54),
                rgba(175, 115, 255, 0) $linear-end
              );
            }
          }
          .gift-pic {
            // width: 100%;
            // height: 100%;
            max-width: 100%;
            max-height: 100%;
          }
          .gift-pic-dom {
            width: 100%;
            height: 100%;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center center;
          }
          .name {
            color: #593d20;
            font-size: 0.2rem;
            position: absolute;
            bottom: 0.1rem;
            left: 0;
            width: 100%;
          }
        }
        .gold {
          $height: (1 - $info-height) * 100%;
          height: $height;
          font-size: 0.23rem;
          font-weight: 600;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;

          .icon {
            font-size: 1em;
          }
        }
      }
    }
  }
}
.gift-pop-box {
  text-align: center;
  margin-bottom: 0.2rem;
  .gift-info {
    font-size: 0.26rem;
    color: #fff;
    .num {
      color: #e7c569;
      margin: 0.1rem;
    }
  }
  .gift-open-info {
    margin: 0.1rem 0;
    font-size: 0.26rem;
    color: #cbcbcb;
  }
  .gift-icon {
    height: 0.76rem;
    display: block;
    margin: 0.15rem auto;
    vertical-align: middle;
  }

  .done-btn {
    height: 0.56rem;
    width: 1.78rem;
    line-height: 0.56rem;
    text-align: center;
    font-size: 0.26rem;
    font-weight: 600;
    color: #282728;
  }
}
.gift-getted-pop-box {
  height: 2.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  padding-top: 0.2rem;
  .title {
    font-size: 0.26rem;
    color: #fff;
  }
  .info {
    margin: 0.1rem 0 0.6rem;
    font-size: 0.26rem;
    color: #cbcbcb;
  }

  .done-btn {
    height: 0.56rem;
    width: 1.78rem;
    line-height: 0.56rem;
    text-align: center;
    font-size: 0.26rem;
    font-weight: 600;
    color: #282728;
  }
}
</style>
